import { shallowEqual, useSelector } from 'react-redux';
import State from 'types/State';

import { getFavoritedVins } from 'redux-implementations/selectors';

export function useFavoritedVins(): string[] {
  return useSelector((state: State) => getFavoritedVins(state), shallowEqual);
}

export function useIsVinFavorited(vin: string): boolean {
  return useFavoritedVins().includes(vin);
}
